import type { ReactNode } from 'react'

import { Paper } from '@twisto/components/atoms/paper'

import * as styles from './category-paper.styles'

type Props = {
  children: ReactNode
  as?: 'div' | 'article'
}

export const CategoryPaper = ({ children, as }: Props) => (
  <Paper noMargin noPadding as={as} css={styles.root}>
    {children}
  </Paper>
)
